import React from 'react';

import { CommunityPreferenceType } from 'types/communities';

import { hasAnyReviewAlertNotificationEnabled } from './utils';
import CommunitySettingLabel from '../../CommunitySettingLabel';
import { COMMUNITY_LABEL_COLOR, COMMUNITY_REVIEW_ALERTS } from '../../constants';

type Props = {
  item: CommunityPreferenceType;
};

const CommunityReviewAlertsStatus = ({ item }: Props) => {
  const { statusElements } = COMMUNITY_REVIEW_ALERTS;
  const activeStatus = hasAnyReviewAlertNotificationEnabled(item) ? statusElements.ON : statusElements.OFF;

  if (activeStatus.value !== statusElements.OFF.value) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
        <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.POSITIVE}>{activeStatus.label}</CommunitySettingLabel>
      </div>
    );
  }

  return (
    <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.NEUTRAL}>{statusElements.OFF.label}</CommunitySettingLabel>
  );
};

export default CommunityReviewAlertsStatus;
